/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetCaseVersionsResponseJson } from './get-case-versions-response-json';
import { GetCaseVersionsResult } from '../results/get-case-versions-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ClearanceCaseDto } from '../models/clearance-case-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetCaseVersionsResponse extends ResponseWithErrorGeneric<GetCaseVersionsResponseJson, GetCaseVersionsResult> implements IResponseWithErrorGeneric<GetCaseVersionsResult> {
  public clearanceCase: ClearanceCaseDto;
  public versions: ClearanceCaseDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetCaseVersionsResponse>) {
    super(response, GetCaseVersionsResult.Error);

    if (this.result !== GetCaseVersionsResult.Success) {
      return;
    }

    this.clearanceCase = this.body.clearanceCase ? new ClearanceCaseDto(this.body.clearanceCase, null) : null;
    this.versions = this.body.versions ? this.body.versions.map(c => new ClearanceCaseDto(c, null)) : [];
  }
  //</custom-body>
}
